// extracted by mini-css-extract-plugin
module.exports = {"host":"AppBreadcrumbs_host__EjKGq","link":"AppBreadcrumbs_link__1ioW4","text":"AppBreadcrumbs_text__143Sq","placeholder":"AppBreadcrumbs_placeholder__2MxGQ"};